import { gql } from "apollo-boost";

export const CAT_MERGE = gql`
  mutation(
    $catId: Int
    $catName: String!
    $catDesc: String!
    $catType: String!
    $updateSource: String!
  ) {
    categoryMerge(
      categoryData: {
        catId: $catId
        catName: $catName
        catDesc: $catDesc
        catType: $catType
        updateSource: $updateSource
      }
    ) {
      node {
        catId
        catName
        catDesc
        catType
      }
    }
  }
`;

export const CAT_DELETE = gql`
  mutation categoryDelete($catId: Int!) {
    categoryDelete(catId: $catId) {
      status
    }
  }
`;

export const CAT_VALUE_MERGE = gql`
  mutation CatValueMerge(
    $valId: Int
    $catId: Int!
    $valName: String!
    $valDesc: String!
    $obsolete: String!
    $updateSource: String!
  ) {
    catValueMerge(
      categoryValueData: {
        valId: $valId
        catId: $catId
        valName: $valName
        valDesc: $valDesc
        obsolete: $obsolete
        updateSource: $updateSource
      }
    ) {
      node {
        valId
        catId
        valName
        valDesc
        obsolete
        updateSource
      }
    }
  }
`;

export const CAT_VALUE_DELETE = gql`
  mutation catValueDelete($valId: Int!) {
    catValueDelete(valId: $valId) {
      status
    }
  }
`;
